// Func = limiting Scope for this file
var lastScrollTop = 0;

var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');


(function(){

	let booking_btn = document.querySelector( ".booking-btn" )
	if( booking_btn ){

		booking_btn.addEventListener( "click", () => {
			let popups = document.querySelector( "v-popups" )
			popups.classList.add( "hidden" )
		} )

		let js_booking_close = document.querySelector( ".js-booking-close" )
		js_booking_close.addEventListener( "click", () => {
			let popups = document.querySelector( "v-popups" )
			popups.classList.remove( "hidden" )
		} )

		

	}

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$('.js-booking-widget').click(function(e) {
			e.preventDefault();
			$('.booking-container').toggleClass('open');
			$('.home-nav').removeClass('open');
		});

		$('.js-booking-close').click(function() {
			$('.booking-container').toggleClass('open');
		});

		$('.js-menu-open').click(function(e) {
			e.preventDefault();
		    $('.home-nav').toggleClass('open');
		});

		$('.js-menu-close').click(function() {
		    $('.home-nav').toggleClass('open');
		});

		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'yy-mm-dd',
			numberOfMonths: 2,
			dayNamesMin: $.datepicker._defaults.dayNamesShort,
		
			beforeShowDay: function (date) {

				setTimeout( () => {
					let booking  = document.getElementById('bookingCalendar');
					let bookingDates = booking.querySelectorAll('.ui-datepicker-calendar td a');

					bookingDates.forEach( item => {
						item.setAttribute('tabindex', -1);
					})
				}, 1000);

				$.datepicker._defaults.dateFormat = "yy-mm-dd";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);
				
				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				let SplitArrive = start.split('-');
				let SplitDeparture = end.split('-');

				$('#altDates').attr('value', (SplitArrive[1] +'/'+ SplitArrive[2]+'/'+ SplitArrive[0]) + ' - ' + (SplitDeparture[1] +'/'+ SplitDeparture[2]+'/'+ SplitDeparture[0]));
			
			},
			onChangeMonthYear: function () {
				
			}
		});


		$("#CheckIn-home").datepicker({
			changeMonth: true,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 1,
			altField:$('#altCheckIn'),
			altFormat:'yy-mm-dd'
		});
		$("#CheckOut-home").datepicker({
			changeMonth: true,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 1,
			altField:$('#altCheckOut'),
			altFormat:'yy-mm-dd'
		});

		/** ADA Tab Links Functionality for Keyboard Navigation **/

		const bookingContainer = document.querySelector('.booking-container');
		const dateInput = document.getElementById('altDates');
		const roomsSelect = document.getElementById('rooms');
		const bookNowButton = document.querySelector('.bookNow');
		const bookingWidgetButton = document.querySelector('.js-booking-widget');
		const bookingCloseButton = document.querySelector('.js-booking-close');

		function setTabIndex(value) {
			[dateInput, roomsSelect, bookNowButton, bookingContainer, bookingCloseButton].forEach(el => {
				if (el) el.tabIndex = value;
			});
		}

		document.addEventListener('focusin', function (event) {
			const isWidgetOpen = bookingContainer.classList.contains('open');
			const isOutsideWidget = !bookingContainer.contains(event.target) && !bookingWidgetButton.contains(event.target);
			
			setTabIndex(isWidgetOpen || isOutsideWidget ? 0 : -1);
		});

		if (bookingWidgetButton) {
			bookingWidgetButton.addEventListener('click', function() {
				bookingContainer.classList.add('open');
				setTabIndex(0);
			});
		}

		if (bookingCloseButton) {
			bookingCloseButton.addEventListener('click', function() {
				bookingContainer.classList.remove('open');
				setTabIndex(-1);
			});
		}

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


